<template>

  <div>
    <div class="headerRow">
      <div class="nodeTitle">MusterStadt</div>
      <div class="nodeInfo" v-if="nodeInfo">
        <div>Interviews: {{nodeInfo.nSelectionInterviews}}</div>
        <div>Trend interviews: {{nodeInfo.nTrendInterviews}}</div>
      </div>
    </div>
    <b-row class="dynrow" no-gutters>
      <template v-for="(widget, index) in widgetData.widgets">
        <b-col class="column" :cols="widget.columns" :key="index">
          <widget-inner :widget-data="widget" ref="childWidgets"/>
        </b-col>
      </template>
    </b-row>
  </div>
</template>

<script>

  import {mapState} from "vuex";

export default {
  name: 'BlockWidget',

    components: {
        'widget-inner': () => import('./Widget.vue')
    },

  data() {
    return {}
  },

  props: {
    widgetData: Object
  },

  computed: {
    ...mapState(['nodeInfo']),
  },

  methods: {
    requestData(requester) {
      // console.log("Ok - BlockWidget call children with requester");
      for(const cw of this.$refs.childWidgets) {
        cw.requestData(requester);
      }
    },
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .column {
    /*background-color: #dddddd;*/
}
  .dynrow {
    /*margin-top: 1em;*/
  }

  .headerRow {
      margin-top: 1em;
      background-color: white;
      border: 1px #dddddd solid;
  }

  .nodeTitle {
    margin-left: 8px;
    font-size: 150%;
  }

</style>
